import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { NzInputModule } from 'ng-zorro-antd/input';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VatDetails } from '@wilson/interfaces';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { CountriesService } from '@wilson/countries';
import { FormControl } from '@angular/forms';
import { PipesModule } from '@wilson/pipes';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'wilson-general-settings-tax',
  templateUrl: './general-settings-tax.component.html',
  styleUrls: ['./general-settings-tax.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    NzInputModule,
    FormsModule,
    ReactiveFormsModule,
    NzSelectModule,
    PipesModule,
    NzTooltipModule,
  ],
  providers: [CountriesService],
})
export class GeneralSettingsTaxComponent {
  @Input() form!: FormGroup<VatDetails>;
  @Input({ required: true }) hasGeneralSettingsUpdatePermission!: boolean;
  @Output() changeVat = new EventEmitter();

  onVatChange(): void {
    this.changeVat.emit();
  }
}
